import { IBaseComponentProps, NSBarTitleProps, NSRouterMakerProps, NSListProduct, NSSpace, NSSpaceSizeType } from 'namirasoft-site-react';
import Styles from './NSAHomePage.module.css';

export interface NSAHomePageProps extends IBaseComponentProps, NSBarTitleProps, NSRouterMakerProps
{
    scope: string;
    title: string;
    icon: string;
    description: string
}

export function NSAHomePage(props: NSAHomePageProps)
{
    return (
        <div className={Styles.nsa_home_container}>
            <img
                src={props.icon}
                alt={props.name}
                width={256}
                height={256}
            />
            <NSSpace size={NSSpaceSizeType.MICRO} />
            <h2>{props.title}</h2>
            <NSSpace size={NSSpaceSizeType.MICRO} />
            <p>{props.description}</p>
            <NSSpace size={NSSpaceSizeType.SMALL} />
            <NSListProduct scope={props.scope} name="Home" />
        </div>
    );
}